<template>
    <div id="app">
        <router-view></router-view>
        <Agreement></Agreement>
    </div>
</template>

<script>
import Agreement from './views/Agreement';
export default {
    name: 'App',
    components: {
        Agreement,
    },
    metaInfo: {
        htmlAttrs: {
            lang: 'cn',
        },
    }
}
</script>

<!--
遇到 Can't resolve 'sass-loader' in 错误解决方法：
cnpm install sass-loader --save
cnpm install node-sass --save
-->
<style lang="scss">
// Import element-ui styles
@import '~element-ui/lib/theme-chalk/index.css';
// Import Main styles for this applcication
@import 'assets/scss/style';
</style>